import { render, staticRenderFns } from "./PhotoClipPreviewDetail.vue?vue&type=template&id=015b4a31&scoped=true"
import script from "./PhotoClipPreviewDetail.vue?vue&type=script&lang=js"
export * from "./PhotoClipPreviewDetail.vue?vue&type=script&lang=js"
import style0 from "./PhotoClipPreviewDetail.vue?vue&type=style&index=0&id=015b4a31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b4a31",
  null
  
)

export default component.exports